import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

// Activity Tracker is a separate module — this file talks to ITS controller,
// not Beacon4PerformanceNetworkOverviewController, since Network Overview only
// reuses the Activity Tracker data (not its own copy of it) to draw activity
// bands on the KPI chart. See GetActivityMarkers on ActivityTrackerController.
const BASE_ACTIVITY_TRACKER = `${config.API_URL}ActivityTracker`;

// Only activities whose StartDate/EndDate are fully contained within
// [dateFrom, dateTo] are returned by the backend (contenção total — see
// ActivityTrackerRepository.GetActivityMarkers). `side`/`vendor` are the SAME
// comma-joined values as the "Filters" group's Side/Vendor multiselects — an
// activity outside what the user already filtered the dashboard to shouldn't
// show up here either. Backend param is named `vendorFilter` (its own
// `vendor` query param is reserved for the privilege-based scope), so it's
// remapped here to keep the call sites elsewhere in this module using the
// same `vendor` name as every other Beacon4 filter param.
export const GetBeacon4PerformanceNetworkOverviewActivityMarkers = (dateFrom, dateTo, side = '', vendor = '') =>
	AxiosRequest({
		method: 'GET',
		url: `${BASE_ACTIVITY_TRACKER}/GetActivityMarkers`,
		params: { startDate: dateFrom, endDate: dateTo, side, vendorFilter: vendor },
	});
